// ListContext.js
import React, { createContext, useState, useContext } from "react";

const ListContext = createContext();

export const useListContext = () => {
  return useContext(ListContext);
};
const getCurrentDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
const getFromDate = () => {
  const today = new Date();
  today.setDate(today.getDate() - 181);
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
export const ListProvider = ({ children }) => {
  const [list, setList] = useState([]);
  const [checkedPlatforms, setCheckedPlatforms] = useState([]);
  const [platforms, setPlatforms] = React.useState([]);
  const [checkedTextStatus, setCheckedTextStatus] = useState([])
  const [verificationStatus, setVerificationStatus] = useState([]);
  const [abuse_type, setAbuse_type] = useState([]);
  const [checkedAbuseTypes, setCheckedAbuseTypes] = useState([]);
  const [keywordsList, setKeywordsList] = useState([]);
  const [checkedTextAIStatus, setCheckedTextAIStatus] = useState([])
  const currentDate = getCurrentDate();
  const fromDate = getFromDate();

  const [dateFilter, setDateFilter] = useState({
    startDate: fromDate,
    endDate: currentDate,
  });

  return (
    <ListContext.Provider
      value={{
        list,setList,
        checkedPlatforms,setCheckedPlatforms,
        verificationStatus,setVerificationStatus,
        abuse_type, setAbuse_type,
        checkedAbuseTypes, setCheckedAbuseTypes,
        dateFilter,setDateFilter,
        keywordsList,setKeywordsList,
        platforms,setPlatforms,
        checkedTextStatus,setCheckedTextStatus,
        checkedTextAIStatus, setCheckedTextAIStatus
      }}
    >
      {children}
    </ListContext.Provider>
  );
};
